import { Validators } from '@angular/forms';

export class BrokerNotesModel {
  notes = {
    value: null,
    validation: Validators.compose([])
  };
}
